export default {
  namespaced: true,

  state: {
    /**
     * @type {Map<number, any>}
     * @description restoreKey: snapshot
     */
    snapshotMap: new Map(),
  },

  mutations: {
    SET_HISTORY_SNAPSHOT(state, { restoreKey, snapshot }) {
      state.snapshotMap.set(restoreKey, snapshot)
    },
  },

  getters: {
    getSnapshot: state => restoreKey => state.snapshotMap.get(restoreKey) ?? null,
    hasSnapshot: state => restoreKey => state.snapshotMap.has(restoreKey),
  },
}
